export const PageConstants = {
    aid: 'auto-id',
    tgn: 'tileGroupName',
    dsm: 'displayShowMore',
    ct: 'containerType',
    tip: 'tileImagePath',
    ftcol: 'favColumnSize',
    hmbeRoute: '/health-enrollment/'
};

